import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import * as FileSaver from 'file-saver';
import * as React from 'react';
import XLSX from 'sheetjs-style';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import moment from 'moment'
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  Tooltip,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  Grid
} from '@mui/material';

import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2'
import { MuiFileInput } from 'mui-file-input'
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import dayjs from 'dayjs';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import { collection, getDocs, getFirestore, addDoc,updateDoc , doc, 
  serverTimestamp, onSnapshot, query, orderBy, limitToLast, Timestamp, writeBatch } from "firebase/firestore";
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from "firebase/database";
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL} from "firebase/storage";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';


// components
import Label from '../../components/label';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/microsite';

import { UserAuth } from '../../context/AuthContext'

const firebaseConfig = {
  apiKey: "AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak",
  authDomain: "onetweb-e3d8e.firebaseapp.com",
  databaseURL: "https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "onetweb-e3d8e",
  storageBucket: "onetweb-e3d8e.firebasestorage.app",
  messagingSenderId: "60910494595",
  appId: "1:60910494595:web:2dc6bf320d67371af04cb6",
  measurementId: "G-0ZTHXZBNP9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'prefix', label: 'Prefix', alignRight: false },
  { id: 'created', label: 'Created', alignRight: false },
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'subtitle', label: 'Sub Title', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy2) {
  if (b[orderBy2] < a[orderBy2]) {
    return -1;
  }
  if (b[orderBy2] > a[orderBy2]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy2) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy2)
    : (a, b) => -descendingComparator(a, b, orderBy2);
}

function applySortFilter(array, comparator, query, select) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {

    if(select === "title"){
      return filter(array, (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    
    if(select === "id"){
      return filter(array, (_user) => _user.id.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

    if(select === "prefix"){
      return filter(array, (_user) => _user.prefix.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

  }
  return stabilizedThis.map((el) => el[0]);
}

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = '.xlsx';

export default function ProductPage() {

  const { user } = UserAuth()

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy2, setOrderBy2] = useState('created');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [row, setRow] = useState([]);

  const [fileUrl, setFileUrl] = useState(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [statusdevice, setStatus] = useState('');
  const [emailaddress, setEmail] = useState('');
  const [cityname, setCity] = useState('');
  const [activationDate, setActivationDate] = useState('');
  const [name, setName] = useState('');
  const [mobileNum, setMobileNum] = React.useState('');
  const [userRole, setUserRole] = useState('super_admin');

  const [edittitle, setedittitle] = React.useState('');
  const [editsubtitle, seteditsubtitle] = React.useState('');
  const [editdecs, seteditdecs] = React.useState('');
  const [editprefix, seteditprefix] = React.useState('');
  

  const handleChangeTitle = (event) => {
    setedittitle(event.target.value);
  };

  const handleChangeSubtitle = (event) => {
    seteditsubtitle(event.target.value);
  };

  const handleChangeDecs = (event) => {
    seteditdecs(event.target.value);
  };

  const handleChangePrefix = (event) => {
    seteditprefix(event.target.value);
  };

  const [select, setSelect] = useState('id');

  const handleChangeSelect = (event) => {
    setSelect(event.target.value);
  };


  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpen2, setDialogOpen2] = useState(false);
  const [dialogOpen3, setDialogOpen3] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [titleError, setTitleError] = React.useState(false);
  const [subtitleError, setSubTitleError] = React.useState(false);
  const [descError, setDescError] = React.useState(false);
  const [headerError, setHeaderError] = React.useState(false);

  const [title, setTitle] = React.useState('');
  const [subtitle, setSubTitle] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [header, setHeader] = React.useState('');
  const [file, setFile] = React.useState(null);
  const [videobg, setVideobg] = React.useState(null);
  const [fileInputError, setFileInputError] = React.useState(false);

  const handleOnChangeUploadfile = (newFile) => {
    setFile(newFile);
  };

  const onHandleTitle = (event) => {
    setTitle(event.target.value)
  };

  const onHandleSubTitle = (event) => {
    setSubTitle(event.target.value)
  };

  const onHandleDescription = (event) => {
    setDescription(event.target.value)
  };

  const onHandleHeader = (event) => {
    setHeader(event.target.value)
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogClose2 = () => {
    setDialogOpen2(false);
  };

  const handleDialogClose3 = () => {
    setDialogOpen3(false);
  };


  const handleDialogSubmit = () => {


    update(dbref(rtdb, `solutions/${selectedItem.id}`), {
      prefix: editprefix || null,
      title: edittitle || null ,
      subtitle: editsubtitle || null ,
      description: editdecs || null 
    }).then(()=>{
      window.location.reload();
    })
    
    setDialogOpen(false); 
  };

  const handleOnDelete = () => {
    setOpenDelete(true);
    setOpen(false)
  }

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleSubmitDelete = async () => {

    const currentIndex = row.map(val=> val.id).indexOf(selectedItem.id)
    
    if (currentIndex > -1) {
      row.splice(currentIndex, 1); 
    }

    remove(child(dbref(rtdb), `solutions/${selectedItem.id}`)).then(()=>{
      setOpenDelete(false);
    })
  }

  useEffect(() => {


    let _user = "";
    if(user && user.reloadUserInfo && user.reloadUserInfo.customAttributes){
      _user = JSON.parse(user.reloadUserInfo.customAttributes);
    }
    setUserRole(_user.role)

      get(child(dbref(rtdb), `solution`)).then((snapshot) => {
        if (snapshot.exists()) {

          setTitle(snapshot.val().title)
          setSubTitle(snapshot.val().subtitle)
          setDescription(snapshot.val().description)
          setHeader(snapshot.val().header)
          setVideobg(snapshot.val().bg_fullPath)

          
          
        } else {

          setTitle('')
          setSubTitle('')
          setDescription('')
          setHeader('')
          setVideobg(null)

          console.log("No data available");
        }

        const arr = [];
        get(child(dbref(rtdb), `solutions`)).then((snapshot2) => {
          if (snapshot2.exists()) {
  
            snapshot2.forEach((doc) => {
  
              arr.push({
                ...doc.val(),
                id: doc.key,
              });
            
              
            })
  
  
            setRow(arr);
            setLoading(false);
  
          } else {
  
            setRow([]);
            setLoading(false);
            console.log("No data available");
          }
        }).catch((error) => {
          console.error(error);
        }); 

      }).catch((error) => {
        console.error(error);
      }); 

   
  }, [])

  const getUnique = (arr, index) => {

    const unique = arr
         .map(e => e[index])
  
         // store the keys of the unique objects
         .map((e, i, final) => final.indexOf(e) === i && i)
    
         // eliminate the dead keys & store unique objects
        .filter(e => arr[e]).map(e => arr[e]);      
  
     return unique;
  }

  const handleChangeMobileNum = (event) => {
    setMobileNum(event.trim())
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value.trim())
  };

  const handleChangeCity = (event) => {
    setCity(event.target.value.trim())
  };

  const handleChangeActivationDate = (event) => {
    setActivationDate(event.target.value.trim())
  };

  const handleChangeName = (event) => {
    setName(event.target.value.trim())
  };


  const downloadExcel = async () => {
    setDialogOpen2(true);
  }

  const downloadExcelCreatedDate = async () => {
    setDialogOpen3(true);
  }

  const handleOnDetails = () => {
    setOpenDetails(true);
    setOpen(false)
  }

  const handleOnEdit = () => {
    seteditprefix(selectedItem.prefix)
    setedittitle(selectedItem.title)
    seteditsubtitle(selectedItem.subtitle)
    seteditdecs(selectedItem.description)
    setDialogOpen(true);
    setOpen(false)
  }

  const handleOpenMenu = (event, row) => {
    setSelectedItem(row)
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy2 === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy2(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = row.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - row.length) : 0;

  const filteredUsers = applySortFilter(row, getComparator(order, orderBy2), filterName, select);

  const isNotFound = !filteredUsers.length && !!filterName;

  if(loading){
    return (
      
      <Grid style={{ width: "100%", display: "flex", alignItems: "center",  flexDirection: "column"  }}>


      <Grid style={{ width: "100%", marginTop: 60, maxWidth: 1200, display: "flex", padding: 25, height: "80vh",
       flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress color="inherit" />
        </Box>
      </Grid>
    </Grid>
    );
  }

  const renderStatus = (status) => {
    let _status = "";
    if(status === "pending_verification"){
      _status = "Pending Verification";
    }
    else if(status === "verified"){
      _status = "Verified";
    }

    return _status;
  }

  const onHandleUploadVideo = () => {

    

    let filePass = false;

    if(file && (file.type === "video/mp4"  )){
      setFileInputError(false)
      filePass = true;
    }
    else
    {
      setFileInputError(true)
    }

    if(filePass)
    {
      setLoading(true);

      const storage = getStorage(app);
      const storageRef = ref(storage, `videobackground/${Timestamp.fromDate(new Date()).toMillis()}_${file.name.replace(/\s/g,'')}`);

      // Get a key for a new Post.

      uploadBytes(storageRef, file).then((snapshot) => {


        getDownloadURL(ref(storage, snapshot.metadata.fullPath))
              .then((url1) => {
                update(dbref(rtdb, `solution` ), {
                  bg_fullPath: url1 || null,
                  bg_contentType: snapshot.metadata.contentType || null
                }).then(()=>{
                  setLoading(false);
                  setFile(null)
                })
                setVideobg(url1)
              })
      })

    }

  }

  const handleSubmit = async (event) => {
      event.preventDefault();
  
      setLoading(true);
  
  
      const data = new FormData(event.currentTarget);
  
      let titlePass = false;
      let subtitlePass = false;
      let descPass = false;
      let headerPass = false;
     
  
      if(data.get('title').length > 2){
        titlePass = true;
        setTitleError(false)
      }
      else
      {
        setTitleError(true)
      }

      if(data.get('subtitle').length > 2){
        subtitlePass = true;
        setSubTitleError(false)
      }
      else
      {
        setSubTitleError(true)
      }

      if(data.get('description').length > 2){
        descPass = true;
        setDescError(false)
      }
      else
      {
        setDescError(true)
      }

      if(data.get('header').length > 2){
        headerPass = true;
        setHeaderError(false)
      }
      else
      {
        setHeaderError(true)
      }
  
  
      if(titlePass && descPass && subtitlePass && headerPass)
      {
        
        update(dbref(rtdb, `solution` ), {
          title: data.get('title'),
          subtitle: data.get('subtitle'),
          description: data.get('description'),
          header: data.get('header'),
        }).then(()=>{
          setLoading(false);
        })
        
      }
      else
      {
        setLoading(false);
      }
      
  
  
    };

  

  return (
    <>
      <Helmet>
        <title> Solutions | OneT </title>
      </Helmet>

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Edit"}
        </DialogTitle>
        <DialogContent>

        <TextField
            style={{ margin: 0, marginTop: 15, width: "100%" }}
            value={editprefix}
            onChange={handleChangePrefix}
            autoComplete='off'
            id="outlined-required"
            label="Prefix"
          />

          <TextField
            style={{ margin: 0, marginTop: 15, width: "100%" }}
            value={edittitle}
            onChange={handleChangeTitle}
            autoComplete='off'
            id="outlined-required"
            label="Title"
          />

        <TextField
            style={{ margin: 0, marginTop: 15, width: "100%" }}
            value={editsubtitle}
            onChange={handleChangeSubtitle}
            autoComplete='off'
            id="outlined-required"
            label="Sub Title"
          />
        <TextField
            style={{ margin: 0, marginTop: 15, width: "100%" }}
            value={editdecs}
            onChange={handleChangeDecs}
            autoComplete='off'
            multiline
            rows={4}
            id="outlined-required"
            label="Description"
          />

          

        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>No</Button>
          <Button onClick={handleDialogSubmit} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Item"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>No</Button>
          <Button onClick={handleSubmitDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Solutions
          </Typography>
          
        </Stack>

        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container style={{ maxWidth: 500 }}>
            <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  required
                  id="title"
                  error={titleError}
                  onChange={onHandleTitle}
                  label="Title"
                  value={title}
                  name="title"
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
                <TextField
                  fullWidth
                  required
                  onChange={onHandleSubTitle}
                  error={subtitleError}
                  id="subtitle"
                  label="Sub Title"
                  name="subtitle"
                  value={subtitle}
                  autoComplete="off"
                />
              </Grid>

              <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
                <TextField
                  fullWidth
                  required
                  onChange={onHandleDescription}
                  error={descError}
                  id="description"
                  label="Description"
                  name="description"
                  autoComplete="off"
                  value={description}
                  multiline
                  rows={4}
                />
              </Grid>

              <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
                <TextField
                  fullWidth
                  required
                  onChange={onHandleHeader}
                  error={headerError}
                  id="header"
                  label="Header"
                  name="header"
                  autoComplete="off"
                  value={header}
                />
              </Grid>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Submit
              </Button>

              <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
                  <MuiFileInput color='primary'
                  required
                  style={{ width: "100%"}}
                  error={fileInputError}
                  placeholder="Upload Background Video*"
                  getInputText={(value) => value ? value.name : 'Upload Background Video*'}
                  inputProps={{ accept: 'video/mp4' }}
                  value={file} onChange={handleOnChangeUploadfile} />
                  <Typography style={{ fontSize: 12, color: "black", marginTop: 10, opacity:.6 }}>
                                      *Video Resolution (W)1920px x (H)1080px
                                      </Typography>
              </Grid>
              {videobg ? <Grid item xs={12} md={12} style={{ marginTop: 5 }}>
                <video height={50} playsInline autoPlay loop muted>
                    <source src={videobg} type='video/mp4' />
                </video>
              </Grid> : null }

              <Button
                onClick={onHandleUploadVideo}
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Upload Background Video
              </Button>

          </Grid>
        </Box>

        <Card>
            <UserListToolbar 
            handleChangeSelect={handleChangeSelect}
            select={select}
            numSelected={selected.length} 
            filterName={filterName} 
            button={<Button variant="contained" href='/dashboard/new_solution' startIcon={<Iconify icon="eva:plus-fill" />}>
                    New Solution
                  </Button>
                  }
            onFilterName={handleFilterByName} />
  
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy2}
                    headLabel={TABLE_HEAD}
                    rowCount={row.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    
                  />
                  
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      const { id } = row;
                      const selectedUser = selected.indexOf(id) !== -1;
  
                    
                      return (
                        <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, id)} />
                          </TableCell>
  
                          <TableCell align="left">
                          {row.id}
                          </TableCell>
  
                          <TableCell align="left">
                            <Typography align='left' style={{ fontSize: 14 }}>{`${new Date(row.created).getFullYear()}
                          -${new Date(row.created).getMonth()+1}
                          -${new Date(row.created).getDate()}`}
                            </Typography>
                            <Typography align='left' style={{ fontSize: 14 }}>
                              {`${new Date(row.created).getHours()}: ${new Date(row.created).getMinutes()}`}
                            </Typography>
                          </TableCell>
  
                          <TableCell align="left"><Tooltip title={row.title}>
                          <Typography sx={{
                              fontSize: 14,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                  WebkitLineClamp: '2',
                                  WebkitBoxOrient: 'vertical',
                              }}>
                            {row.title}
                            </Typography>
                            </Tooltip></TableCell>

                            <TableCell align="left"><Tooltip title={row.subtitle}>
                          <Typography sx={{
                              fontSize: 14,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                  WebkitLineClamp: '2',
                                  WebkitBoxOrient: 'vertical',
                              }}>
                            {row.subtitle}
                            </Typography>
                            </Tooltip></TableCell>
                          
                          <TableCell style={{overflow: "hidden", textOverflow: "ellipsis", width: '11rem'}} align="left">
                          <Tooltip title={row.description}>
                            <Typography sx={{
                              fontSize: 14,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                  WebkitLineClamp: '2',
                                  WebkitBoxOrient: 'vertical',
                              }}>
                            {row.description}
                            </Typography>
                            </Tooltip>
                          </TableCell>
  
  
  
                          <TableCell align="right">
                            <IconButton size="large" color="inherit" onClick={(e)=> handleOpenMenu(e, row)}>
                              <Iconify icon={'eva:more-vertical-fill'}/>
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
  
                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>
  
                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
  
                  
                </Table>
              </TableContainer>
            </Scrollbar>
  
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              component="div"
              count={row.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >

{userRole === "super_admin" ? <MenuItem onClick={handleOnEdit} >
            <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
            Edit
          </MenuItem> : null}
          <MenuItem onClick={handleOnDelete} sx={{ color: 'error.main' }}>
            <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
            Delete
          </MenuItem>

          
      </Popover>
    </>
  );
}
